import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';

import { DELIVERY_ZIPCODE_GET_REQUEST_SUCCESS } from '../actionTypes/DeliveryZipcodeActionTypes';
import { cachePolicy } from '../config';

const zipCodeFromLocalStorage = LocalStorage.getData('deliveryZipcode');
let initialState = '';

/* istanbul ignore next */
if (
    zipCodeFromLocalStorage &&
    zipCodeFromLocalStorage.zipcode &&
    new Date() - new Date(zipCodeFromLocalStorage.date) <= cachePolicy.minCache
) {
    initialState = zipCodeFromLocalStorage.zipcode;
} else {
    initialState = '';
}

function DeliveryZipcodeReducer(state = initialState, action) {
    switch (action.type) {
        case DELIVERY_ZIPCODE_GET_REQUEST_SUCCESS:
            if (action.payload.setLocalstorage) {
                LocalStorage.setData('deliveryZipcode', {
                    zipcode: action.payload.zipcode,
                    date: new Date(),
                });
            }
            return action.payload.zipcode;
        default:
            return state;
    }
}

export default DeliveryZipcodeReducer;
